/* mjade-card-hint — 목록 «2번째 카드» 가 스스로 한 번 밀렸다 돌아온다 (2026-09-03)
 *
 * 왜 있나: 카드를 옆으로 밀면 색이 바뀐다는 것을 손님이 «모르고 지나친다».
 *   한 번 스스로 보여 주면 「밀 수 있다」와 「색이 여럿이다」를 한 번에 알린다.
 *   그래서 사진이 밀리는 동안 아래 색칩도 «같이» 열린다 — 둘은 한 가지 안내다.
 *
 * ★ 값은 한국몰 목록의 함수 「보여주기」를 원문으로 읽어 그대로 옮겼다.
 *   [확인됨·범위: m.mjade.co.kr/product/list.html?cate_no=145 를 2026-09-03 에 내려받아
 *    (SOURCE/_MANIFEST.tsv) 함수 전문을 대조 — 8/27 스킨 백업본과 글자 단위로 같았다]
 *
 *     발동   목록 화면 · 모바일 · 첫 «스크롤» · 페이지당 1회
 *            prefers-reduced-motion: reduce 이면 아예 안 한다
 *     대상   그려진 카드 중 «2번째» · 스와치 2개 이상 ·
 *            사진이 화면 안에 «통째로» 들어와 있을 때만 (아니면 다음 스크롤에 다시)
 *     나감   지금 사진과 다음 색 사진이 함께 translate3d(-100%,0,0)
 *            transform .75s cubic-bezier(.16,1,.3,1)
 *     +300ms 감춘 색칩이 translate3d(-8px,0,0)·투명 에서 제자리로
 *            transform .4s cubic-bezier(.16,1,.3,1), opacity .4s ease · 60ms 씩 늦게
 *            「+N more」는 translate3d(6px,0,0)·투명 으로 물러난다 (같은 .4s)
 *     +1800  되돌아온다 · transform .7s cubic-bezier(.65,0,.35,1)
 *            +180ms 칩이 «역순» 으로 사라진다
 *                   transform .32s cubic-bezier(.65,0,.35,1), opacity .32s ease · 40ms 씩
 *            320+(n-1)*40ms 뒤 다시 접고 「+N more」 복귀
 *     +950   정리 (복제 사진 제거 · 인라인 값 원상복구)
 *     끊김   손이 닿으면(touchstart·mousedown) 즉시 .2s ease 로 돌아오고 260ms 뒤 정리
 *
 *   한국 실측 기준선 [확인됨·범위: 430px 아이폰 UA 로 1회 그려 30ms 간격 관측]:
 *     사진 -211px(=100%) 도달 ~750ms / 칩 열림 331ms / 되돌림 시작 1860ms /
 *     사진 제자리 2551ms / 정리 2791ms
 *
 * ★ 일본에만 필요한 두 가지 — 한국에는 없던 «사정» 이지 값의 변경이 아니다
 *   ① 다음 색 사진이 아직 없다.
 *      한국은 사진 요소가 하나뿐이라 src 만 갈아끼우면 됐다. 일본은 색마다 요소가
 *      따로이고, 카드를 가볍게 하려고 «손이 닿을 때» 만든다(mjade-card-color.js 의 wake).
 *      그래서 먼저 깨우고, 그 사진이 «실제로 그려질 수 있을 때» 까지 기다렸다 시작한다.
 *      안 기다리면 흰 칸이 지나간다 — 2026-09-02 에 대표님이 지적하신 그 증상이다.
 *      기다리는 상한 400ms 는 theme.liquid 의 밀기가 쓰는 값과 같게 맞췄다.
 *   ② 감춘 색칩을 여는 방법이 두 겹이다.
 *      한국은 data-mj-hide 하나지만 일본은 인라인 display:none 과 --truncated 클래스다.
 *      그래서 줄에 data-mj-open 을 세워 열고, 되돌릴 때는 layoutRail 을 다시 불러
 *      «원래 접힘» 을 그 스크립트가 직접 만들게 한다 — 접는 규칙을 여기 두지 않는다.
 *      여는 동안 data-mj-busy 를 세워 다른 카드의 펼치기·접기와 안 부딪히게 한다.
 *
 * ★ 사진은 복제본 한 장을 «새로 만들어» 쓴다 — 테마의 .product-block__image 를
 *   건드리지 않는다. 그래서 밀기(shown())·잠금(mj-slide-lock)·테마의 사진 넘김 중
 *   어느 것도 이 복제본을 보지 못한다. 색은 실제로 «바뀌지 않는다» — 안내일 뿐이다.
 *
 * 되돌리기: layout/theme.liquid 의 script 한 줄을 지운다.
 */
(function () {
  'use strict';
  if (window.__mjCardHint) return;
  window.__mjCardHint = true;

  var MOBILE_MAX = 767;

  /* ── 한국 원문 값. 고치지 않는다 ─────────────────────────────── */
  var OUT_EASE  = 'transform .75s cubic-bezier(.16,1,.3,1)';
  var BACK_EASE = 'transform .7s cubic-bezier(.65,0,.35,1)';
  var FAST_EASE = 'transform .2s ease';
  var CHIP_IN   = 'transform .4s cubic-bezier(.16,1,.3,1), opacity .4s ease';
  var CHIP_OUT  = 'transform .32s cubic-bezier(.65,0,.35,1), opacity .32s ease';
  var STEP_IN = 60, STEP_OUT = 40;
  var T_CHIP = 300, T_BACK = 1800, T_CHIPBACK = 180, T_CHIPCLEAN = 320;
  var T_END = 950, T_END_FAST = 260;
  /* ── 일본 사정 ─────────────────────────────────────────── */
  var WAIT_IMG = 400;

  var used = false;                     /* 페이지당 1회 */

  function isList(){ return document.body.classList.contains('template-collection'); }
  function isMobile(){
    try { return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches; }
    catch (e) { return false; }
  }

  /* 한국과 같은 고르기 — 그려진 카드 중 2번째, 사진이 화면 안에 통째로 있을 때만 */
  function pick(){
    var all = document.querySelectorAll('product-block.product-block');
    var cards = [];
    for (var i = 0; i < all.length; i++){
      if (all[i].getBoundingClientRect().height > 0) cards.push(all[i]);
    }
    if (cards.length < 2) return null;
    var card = cards[1];
    if (card.getAttribute('data-mj-sliding') === '1') return null;   /* 밀기 중이면 비킨다 */
    var rail = card.querySelector('.product-block-options--swatch');
    if (!rail || rail.querySelectorAll('.product-block-options__item').length < 2) return null;
    var cont = card.querySelector('.image-cont');
    if (!cont) return null;
    var cur = cont.querySelector('.product-block__image--active');
    var curImg = cur ? cur.querySelector('img') : null;
    if (!cur || !curImg) return null;
    var r = cont.getBoundingClientRect();
    var h = window.innerHeight || 800;
    if (!r.width || r.top < 0 || r.bottom > h) return null;
    return { card: card, rail: rail, cont: cont, cur: cur, curImg: curImg };
  }

  /* 한국과 같은 규칙 — 같은 묶음에서 «지금과 다른 색» 의 첫 사진.
     같은 색의 둘째 컷(mj-hover-shot)은 색이 아니므로 뺀다. */
  function nextShot(o){
    var all = o.cont.querySelectorAll('.product-block__image');
    for (var i = 0; i < all.length; i++){
      var e = all[i];
      if (e === o.cur) continue;
      if (e.classList.contains('mj-hover-shot')) continue;
      var im = e.querySelector('img');
      if (im && !im.hasAttribute('data-manual-src') && (im.currentSrc || im.src)) return im;
    }
    return null;
  }

  function run(){
    if (used) return;
    if (!isList() || !isMobile()) return;
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches){ used = true; return; }
    } catch (e) {}

    var o = pick();
    if (!o) return;

    /* ① 다음 색 사진을 만들게 한다 (mjade-card-color.js 가 규칙을 갖고 있다) */
    if (typeof window.__mjCardWake === 'function'){
      try { window.__mjCardWake(o.card); } catch (e) {}
    }
    var src = nextShot(o);
    if (!src) return;

    var demo = document.createElement('img');
    demo.className = 'mj-card-hint';
    demo.setAttribute('alt', '');
    demo.setAttribute('aria-hidden', 'true');
    var ss = src.getAttribute('srcset'), sz = src.getAttribute('sizes');
    if (ss) demo.setAttribute('srcset', ss);
    if (sz) demo.setAttribute('sizes', sz);
    demo.src = src.currentSrc || src.src;
    var cs = window.getComputedStyle(o.curImg);
    /* 한국 CSS(.mj-sw-demo)와 같은 자리·같은 채움. 새로 만든 요소라 겹칠 규칙이 없다. */
    demo.style.cssText =
      'position:absolute;left:100%;top:0;width:100%;height:100%;z-index:2;'
      + 'pointer-events:none;object-fit:' + cs.objectFit
      + ';object-position:' + cs.objectPosition + ';';

    /* ② 그려질 수 있을 때까지만 기다린다. 못 받으면 이번엔 안 한다 — 다음 스크롤에 다시. */
    var t0 = Date.now();
    (function ready(){
      if (used) return;
      if (demo.complete && demo.naturalWidth > 0){ start(o, demo); return; }
      if (Date.now() - t0 > WAIT_IMG) return;
      setTimeout(ready, 32);
    })();
  }

  function start(o, demo){
    if (used) return;
    used = true;
    window.removeEventListener('scroll', onScroll);

    o.cont.appendChild(demo);
    o.card.setAttribute('data-mj-hint', '1');

    var img = o.curImg;
    var rail = o.rail;
    var items = [].slice.call(rail.querySelectorAll('.product-block-options__item'));
    var more = rail.querySelector('.product-block-options__more-label');
    var opened = [];
    var timers = [], ended = false;

    function later(f, ms){ timers.push(setTimeout(f, ms)); }
    function stop(){
      if (ended) return;
      for (var t = 0; t < timers.length; t++) clearTimeout(timers[t]);
      back(true);
    }
    o.card.addEventListener('touchstart', stop, { passive: true });
    o.card.addEventListener('mousedown', stop, true);

    img.style.transition = 'none';
    img.style.transform = 'translate3d(0,0,0)';
    demo.style.transition = 'none';
    demo.style.transform = 'translate3d(0,0,0)';
    void img.offsetWidth;                       /* 리플로우 강제 — 없으면 안 움직인다 */
    img.style.transition = OUT_EASE;
    img.style.transform = 'translate3d(-100%,0,0)';
    demo.style.transition = OUT_EASE;
    demo.style.transform = 'translate3d(-100%,0,0)';

    later(function () {
      var hid = [];
      for (var i = 0; i < items.length; i++){
        if (items[i].style.display === 'none') hid.push(items[i]);
      }
      if (hid.length){
        rail.setAttribute('data-mj-busy', '1');   /* 다른 카드의 접기·펼치기와 안 부딪히게 */
        rail.setAttribute('data-mj-open', '1');   /* --truncated 를 풀어 주는 문 */
      }
      for (var k = 0; k < hid.length; k++){
        (function (it, n) {
          opened.push(it);
          it.style.removeProperty('display');
          it.style.transition = 'none';
          it.style.transform = 'translate3d(-8px,0,0)';
          it.style.opacity = '0';
          void it.offsetWidth;
          it.style.transition = CHIP_IN;
          it.style.transitionDelay = (n * STEP_IN) + 'ms';
          it.style.transform = 'translate3d(0,0,0)';
          it.style.opacity = '1';
        })(hid[k], k);
      }
      if (more && opened.length){
        more.style.transition = CHIP_IN;
        more.style.transform = 'translate3d(6px,0,0)';
        more.style.opacity = '0';
      }
    }, T_CHIP);

    later(function () { back(false); }, T_BACK);

    function back(fast){
      if (ended) return;
      ended = true;

      var ease = fast ? FAST_EASE : BACK_EASE;
      void img.offsetWidth;
      img.style.transition = ease;
      img.style.transform = 'translate3d(0,0,0)';
      demo.style.transition = ease;
      demo.style.transform = 'translate3d(0,0,0)';
      /* 손이 닿았으면 줄을 더 잠가 두지 않는다 — 바로 이어서 펼치실 수 있게. */
      if (fast) rail.removeAttribute('data-mj-busy');

      setTimeout(function () {
        for (var k = opened.length - 1; k >= 0; k--){
          (function (it, n) {
            it.style.transition = CHIP_OUT;
            it.style.transitionDelay = (n * STEP_OUT) + 'ms';
            it.style.transform = 'translate3d(-8px,0,0)';
            it.style.opacity = '0';
          })(opened[k], opened.length - 1 - k);
        }
        var chipEnd = fast ? 0
          : (T_CHIPCLEAN + Math.max(0, opened.length - 1) * STEP_OUT);
        setTimeout(function () {
          if (opened.length){
            rail.removeAttribute('data-mj-open');
            /* 접는 규칙은 mjade-best-sellers-mobile.js 한 곳에만 둔다 */
            if (typeof window.__mjRailLayout === 'function'){
              try { window.__mjRailLayout(rail); } catch (e) {}
            }
          }
          if (more && opened.length){
            more.style.transition = CHIP_OUT;
            more.style.transform = 'translate3d(0,0,0)';
            more.style.opacity = '1';
          }
        }, chipEnd);
      }, fast ? 0 : T_CHIPBACK);

      setTimeout(function () {
        for (var k = 0; k < opened.length; k++){
          opened[k].style.transition = '';
          opened[k].style.transitionDelay = '';
          opened[k].style.transform = '';
          opened[k].style.opacity = '';
        }
        if (more){
          more.style.transition = '';
          more.style.transform = '';
          more.style.opacity = '';
        }
        img.style.transition = '';
        img.style.transform = '';
        if (demo.parentNode) demo.parentNode.removeChild(demo);
        rail.removeAttribute('data-mj-open');
        rail.removeAttribute('data-mj-busy');
        if (opened.length && typeof window.__mjRailLayout === 'function'){
          try { window.__mjRailLayout(rail); } catch (e) {}
        }
        o.card.removeAttribute('data-mj-hint');
        o.card.removeEventListener('touchstart', stop);
        o.card.removeEventListener('mousedown', stop, true);
      }, fast ? T_END_FAST : T_END);
    }
  }

  function onScroll(){ run(); }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
